// Supabase Configuration
// Update these values with your actual Supabase project details

export const SUPABASE_CONFIG = {
  // Your Supabase project URL
  URL: process.env.REACT_APP_SUPABASE_URL || 'https://wncbbphhnhggvcwrgpbx.supabase.co',
  
  // Your Supabase anon/public key
  ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InduY2JicGhobmhnZ3Zjd3JncGJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY4MDI2MTcsImV4cCI6MjA3MjM3ODYxN30.XcvGx29eLZE6mFljB26xHahzaZIK27dF8WfVoQ85mB0',
  
  // API endpoints
  API_ENDPOINTS: {
    CATEGORIES: '/rest/v1/categories',
    PROJECTS: '/rest/v1/projects',
  },
  
  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
};

// Helper function to get headers with authentication
export const getAuthHeaders = () => ({
  'apikey': SUPABASE_CONFIG.ANON_KEY,
  'Authorization': `Bearer ${SUPABASE_CONFIG.ANON_KEY}`,
  ...SUPABASE_CONFIG.DEFAULT_HEADERS,
});

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string, query?: string) => {
  const baseUrl = `${SUPABASE_CONFIG.URL}${endpoint}`;
  return query ? `${baseUrl}?${query}` : baseUrl;
};
